import { WS_BASE_URL } from "../utils/constants";


export function openMatchmakingSocket(categorySlug, { onMessage, onOpen, onClose }) {
const ws = new WebSocket(`${WS_BASE_URL}/ws/matchmaking/${categorySlug}/`);
ws.onopen = () => onOpen && onOpen(ws);
ws.onmessage = (e) => {
try { const data = JSON.parse(e.data); onMessage && onMessage(data); }
catch { /* ignore */ }
};
ws.onclose = () => onClose && onClose();
return ws;
}